import HomePage from './HomePage';

export { HomePage };
export default HomePage;
